import React from 'react';
import Widget from 'components/Widget/Widget';

import ProductSalesTable from './Tables/ProductSalesTable';

const ProductSales = ({
  height,
  index,
  data,
  configuration,
  disableFilter,
  cardFilterComponent,
}) => {
  return (
    <Widget
      icon={
        data?.defaultFilter?.integration_type ? (
          <img
            src={`/icons/integrations/${data?.defaultFilter?.integration_type}.svg`}
            className='w-5 h-5 '
          />
        ) : null
      }
      cardFilterComponent={cardFilterComponent}
      tableWidget
      widget_key={'product_sales' + index}
      title={data.title}
      index={index}
      deleteWidget={true}
      data={data}
      default_filter={data.defaultFilter}
      configuration={configuration}
      disableDateFilter
      disableStatusFilter
      disableAccountsFilter
      design={false}
      disableFilter={disableFilter}
      position={data?.position}
      showIntegrationFilters
      dashboard_widget_key={data?.key}
    >
      <ProductSalesTable height={height} index={index} />
    </Widget>
  );
};

export default ProductSales;
